import { ProjectReducer } from 'reduxm/reducer'

export default ProjectReducer
